export function isGenieTagActive(tag) {
  return String(tag?.status ?? "") === "1";
}

export function countInactiveGenieTags(tags) {
  return Array.isArray(tags)
    ? tags.reduce((count, tag) => count + (isGenieTagActive(tag) ? 0 : 1), 0)
    : 0;
}

export function markGenieTagsActive(tags, plateCode = null) {
  if (!Array.isArray(tags)) return [];

  return tags.map((tag) =>
    !plateCode || tag?.plate_code === plateCode
      ? { ...tag, status: "1" }
      : tag
  );
}
